export const DefaultPaySection = {
    path: '/default_pay_sections',
    name: 'default_pay_sections',
    component: () => import('@/views/DefaultPaySection/DefaultPaySectionPage.vue'),
    children: [
        {
            path: '/default_pay_sections/add',
            name: 'default_pay_sections.add',
            component: () => import('@/views/DefaultPaySection/Form/DefaultPaySectionForm.vue'),
            props: { addAction: true }
        },
        {
            path: '/default_pay_sections/edit/:id',
            name: 'default_pay_sections.edit',
            component: () => import('@/views/DefaultPaySection/Form/DefaultPaySectionForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/default_pay_sections/delete/:id',
            name: 'default_pay_sections.delete',
            component: () => import('@/views/DefaultPaySection/Form/DefaultPaySectionForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/default_pay_sections/view/:id',
            name: 'default_pay_sections.view',
            component: () => import('@/views/DefaultPaySection/Form/DefaultPaySectionForm.vue'),
            props: {viewAction: true}
        },
    ],
}